
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchInTaxGrid extends Serenity.EntityGrid<BranchInTaxRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchInTax'; }
        protected getDialogType() { return BranchInTaxDialog; }
        protected getIdProperty() { return BranchInTaxRow.idProperty; }
        protected getInsertPermission() { return BranchInTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchInTaxRow.localTextPrefix; }
        protected getService() { return BranchInTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}